export const assetsUrl = (path: string) => `/assets/${path}`;
export const brandUrl = (filename: string) => assetsUrl(`brand/${filename}`);
export const iconsUrl = (filename: string) => assetsUrl(`icons/${filename}`);
export const errorUrl = (filename: string) => assetsUrl(`errors/${filename}`);
export const defaultUrl = (filename: string) => assetsUrl(`default/${filename}`);
export const loadersUrl = (filename: string) => assetsUrl(`loaders/${filename}`);
export const socialMediaIconUrl = (filename: string) => assetsUrl(`social-media-icons/${filename}`);
export const onboardingUrl = (filename: string) => assetsUrl(`onboarding/${filename}`);

export const placeholderUrl = (filename: string) => `https://www.website.com/${filename}`;

export const BrandAssets = {
	logo: brandUrl('game-contract-logo.svg'),
	hashupLogo: brandUrl('hashup-logo.svg'),
	hodlLogo: brandUrl('hodl-logo.svg'),
};

export const ErrorAssets = {
	invalidCartridge: errorUrl('invalid-cartridge.png'),
	invalidIcon: errorUrl('invalid-icon.png'),
	invalidBanner: errorUrl('invalid-banner.png'),
};

export const DefaultAssets = {
	defaultAvatar: defaultUrl('avatar.png'),
};

export const PlatformIconAssets = {
	html: iconsUrl('html.svg'),
	pc: iconsUrl('pc.svg'),
} as const;

export const OnboardingAssets = {
	metamask: onboardingUrl('metamask-onboarding.png'),
	matic: onboardingUrl('matic-onboarding.png'),
	images: onboardingUrl('images-onboarding.png'),
	gamepad: onboardingUrl('gamepad-onboarding.png'),
} as const;

export const LoaderAssets = {
	spinner: loadersUrl('spinner.gif'),
	upload: loadersUrl('upload.gif'),
	cartridge: loadersUrl('cartridge.gif'),
	completed: loadersUrl('completed.gif'),
} as const;

export const IconAssets = {
	wallet: iconsUrl('wallet.svg'),
	chevronLeft: iconsUrl('chevron-left.svg'),
	chevronRight: iconsUrl('chevron-right.svg'),
	tooltipCircle: iconsUrl('tooltip-circle.svg'),
	chevronDown: iconsUrl('chevron-down.svg'),
	chevronUp: iconsUrl('chevron-up.svg'),
	zoomScreenshot: iconsUrl('zoom-screenshot.svg'),
	hashSmall: iconsUrl('hash-small.svg'),
	copyAddress: iconsUrl('copy-red.svg'),
	copyAdressConfirmed: iconsUrl('copy-confirm.svg'),
	globe: iconsUrl('globe.svg'),
	deleteScreenshot: iconsUrl('trash.svg'),
	addScreenshot: iconsUrl('plus-square.svg'),
	exitCircle: iconsUrl('x-circle.svg'),
	hamburgerRed: iconsUrl('hamburger_red.svg'),
	addToMetamask: iconsUrl('add-to-metamask.svg'),
	dollar: iconsUrl('$.svg'),
	save: iconsUrl('save.svg'),
	users: iconsUrl('users.svg'),
	steam: iconsUrl('steam.png'),
};

export const SocialMediaUrls = {
	facebook: 'https://www.facebook.com/HashUpIt',
	linkedIn: 'https://www.linkedin.com/company/hashupit',
	instagram: 'https://www.instagram.com/hashup.it/',
	telegram: 'https://t.me/HashUpAnnouncements',
	twitter: 'https://twitter.com/HashUp_it',
	discord: 'https://discord.gg/ZxwhHb7R9e',
	gitbook: 'https://hashup-it.gitbook.io/hashup-it-1/',
} as const;

export const FileUrls = {
	dataProtectionPolicy: 'https://cdn.hashup.it/legal-packages/GameContract_DataProtectionPolicy.pdf',
	termsAndCondition: 'cdn.hashup.it/legal-packages/GameXplorer_TermsAndConditions.pdf',
} as const;

export const SocialMediaIcons = {
	facebook: socialMediaIconUrl('facebook.svg'),
	linkedin: socialMediaIconUrl('linkedin.svg'),
	instagram: socialMediaIconUrl('instagram.svg'),
	telegram: socialMediaIconUrl('telegram.svg'),
	twitter: socialMediaIconUrl('twitter.svg'),
	discord: socialMediaIconUrl('discord.svg'),
	dribble: socialMediaIconUrl('dribble.svg'),
	youtube: socialMediaIconUrl('youtube.svg'),
	github: socialMediaIconUrl('github.svg'),
	metamask: socialMediaIconUrl('metamask.svg'),
	wikipedia: socialMediaIconUrl('wikipedia.ico'),
} as const;

// Dev and prod variables

interface EnvironmentConstants {
	blockchain: {
		contracts: {
			storeV1: string;
			storeV2: string;
			usdc: string;
		};
		chainId: number;
	};
	moralis: {
		appId: string;
		dappUrl: string;
	};
	hashup: {
		gamexplorerUrl: string;
	};
}

const prod: EnvironmentConstants = {
	blockchain: {
		contracts: {
			storeV1: '0x9741708b2dede32c972d3ef7959fa3262860e485',
			storeV2: '0x1aFb90451aBbF5Eb6f59842CAF8949374F1B4683',
			usdc: '0x2791bca1f2de4661ed88a30c99a7a9449aa84174',
		},
		chainId: 137,
	},
	moralis: {
		appId: '001',
		dappUrl: 'https://hashup-moralis-production.up.railway.app/server',
	},
	hashup: {
		gamexplorerUrl: 'https://gamexplorer.io',
	},
};

const dev: EnvironmentConstants = {
	blockchain: {
		contracts: {
			storeV1: '0xa455F248ba4475D11043D029d7dc6FD11270B66e',
			storeV2: '0xFeddE591f50d9de05A39609E479Dd65bc85A1112',
			usdc: '0xf583F23e2b26f1ABd88804704E3826DeafC8A21d',
		},
		chainId: 80001,
	},
	moralis: {
		appId: 'vtTf7ftC58VeOXocaZuqmPKOuzozvXZgIOGON6lL',
		dappUrl: 'https://cawxglhowrkc.grandmoralis.com:2053/server',
	},
	hashup: {
		gamexplorerUrl: 'https://test.gamexplorer.io',
	},
};

export const config = process.env.REACT_APP_ENVIRONMENT === 'dev' ? dev : prod;
